export const CONTENT_STATUS = {
  DRAFT: 'Em construção',
  WAITING: 'Aguardando envio',
  SENDING: 'Em envio',
  SENT: 'Disparado'
}

export const CONTENT_STATUS_COLORS = {
  DRAFT: 'blue',
  WAITING: 'orange',
  SENDING: 'purple',
  SENT: 'green'
}